import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import { Table } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import {
  Chart,
  Point,
  Line,
  Tooltip,
} from 'bizcharts';
import { useSelector } from 'react-redux';
import { isArray, isObject } from 'lodash';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { ShowIf } from '../../../shared/components';

interface PiosProps{
  pios: any,
  setPios: any,
  watch: boolean,
}

export default function PIO({ pios, setPios, watch: watchMode }:PiosProps) {
  const chartContainer = useRef(null);
  const { tienda_id: tiendaId } = useSelector((state: any) => state.auth.user.user_info);
  const [graficaPioState, setGraficaPioState] = useState(false);
  const [data, setData] = useState<Array<any>>();

  const scale = {
    pio: { min: 0 },
    ojo: {
      formatter: (v: any) =>
        // @ts-ignore
        ({
          OjoDerecho: 'Ojo Derecho',
          OjoIzquierdo: 'Ojo Izquierdo',
        }[v]),

    },
  };

  useEffect(() => {
    if (pios && pios != undefined) {
      const dataPrev: Array<any> = [];
      if (isArray(pios)) {
        pios.map((pio:any) => {
          dataPrev.push(
            {
              // @ts-ignore
              fecha: pio.pio_fechor,
              // @ts-ignore
              pio: pio.pio_ojo_derecho,
              // @ts-ignore
              ojo: 'OjoDerecho',
            },
            {
              fecha: pio.pio_fechor,
              // @ts-ignore
              pio: pio.pio_ojo_izquierdo,
              // @ts-ignore
              ojo: 'OjoIzquierdo',
            },
          );
        });
      }
      setData(dataPrev);
    }
  }, [pios]);


  const createRow = (pio: any, index: number) => {
    // @ts-ignore
    const { pio_fechor: fecha, pio_ojo_derecho: ojoDcho, pio_ojo_izquierdo: ojoIzq } = pio;
    return {
      index,
      id: pio.id,
      fecha: <p>{fecha}</p>,
      ojoDcho: <input
        disabled={watchMode}
        className="tableInputs"
        value={ojoDcho}
        onChange={(e) => {
          changePioField(index, 'pio_ojo_derecho', e.target.value);
        }}
      />,
      ojoIzq: <input
        disabled={watchMode}
        className="tableInputs"
        value={ojoIzq}
        onChange={(e) => {
          changePioField(index, 'pio_ojo_izquierdo', e.target.value);
        }}
      />,
    };
  };

  const breakpoint = useBreakpoint();

  function deleteRow(key: any) {
    setPios(pios.filter((pio: any, index:number) => index !== key.index));
  }
  const columnsPio = [
    {
      title: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
    },
    {
      title: 'Ojo Dcho.',
      dataIndex: 'ojoDcho',
      key: 'ojoDcho',
    },
    {
      title: 'Ojo Izq.',
      dataIndex: 'ojoIzq',
      key: 'ojoIzq',
    },
  ];
  if (!watchMode) {
    const d = {
      title: 'Acciones',
      dataIndex: 'delete',
      key: 'delete',
      render: (text: any, record: any) => (pios.length > 0 ? (
        <p className="blueLink" onClick={() => deleteRow(record)}>
          Eliminar
        </p>
      ) : null),
    };
    columnsPio.push(d);
  }

  function createDataRow() {
    // @ts-ignore
    setPios([...pios, {
      id: null,
      codigo_tienda: tiendaId,
      pio_ojo_derecho: '',
      pio_ojo_izquierdo: '',
      pio_fechor: moment().format("DD/MM/YYYY HH:mm:ss"),
    }]);
  }

  const changePioField = (index: number, key: string, value: string) => {
    const piosCopy = [...pios];
    // @ts-ignore
    if(isNaN(value)){
      piosCopy[index][key] = '';
    }else{
      piosCopy[index][key] = value;
    }

    setPios(piosCopy);
  };

  return (
    <>
      <div className={`${breakpoint.isDesktop ? 'width100' : ''} bodyInfo flexCol`}>
        <div className="flexRow">
          <h3 style={{ marginRight: 16 }}>PIO</h3>
          { graficaPioState
            ? <p onClick={() => setGraficaPioState(false)} className="blueLink">Ocultar gráfica PIO</p>
            : <p onClick={() => setGraficaPioState(true)} className="blueLink">Ver gráfica PIO</p>
            }
        </div>
        <div className="inputMarginTop table">
          <Table
            columns={columnsPio}
            dataSource={(() => {
              const rows: Array<any> = [];
              // @ts-ignore
              if (isArray(pios)) {
                pios.forEach((pio: any, index) => {
                  rows.push(createRow(pio, index));
                });
              }
              return rows;
            })()}
            pagination={false}
          />
        </div>
        <ShowIf condition={!watchMode}>
          <div className="addLine" onClick={createDataRow}>
            <div className="flexRow centerHorizontal">
              <FontAwesomeIcon className="add_line" icon={faPlus} />
              <p className="add_line margin-left">Añadir PIO</p>
            </div>
          </div>
        </ShowIf>
      </div>
      { graficaPioState
        ? (
          <div className="bodyInfo flexCol">
            <div className="flexRow spaceBetween marginBot16">
              <h3>Gráfica PIO</h3>
            </div>
            <div ref={chartContainer}>
              <Chart
                scale={scale}
                height={188}
                data={data}
                autoFit
              >
                <Tooltip shared />
                <Line position="fecha*pio" color="ojo" />
                <Point shape="hollow-diamond" position="fecha*pio" color="ojo" label="Pio" />
              </Chart>
            </div>
          </div>
        )
        : <></>
        }
    </>
  );
}
